
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.879 9.35a.621.621 0 01.18-.334H2.3c-.718-.26.02-1.278.48-1.537h.877c.38-.964.759-1.946 1.138-2.927.28-.5.618-.816 1.018-.982 2.514-.76 5.867-.76 8.362 0 .419.166.758.481 1.038.982.379.981.758 1.963 1.117 2.927h.878c.48.259 1.218 1.278.48 1.537h-.74c.08.093.16.223.18.334-.02 1.723.02 3.445.02 5.168 0 .26-.24.482-.538.482h-2.176c-.3 0-.539-.222-.539-.482v-1.056H6.092v1.056c0 .26-.24.482-.519.482H3.378c-.28 0-.52-.222-.52-.482 0-1.723.02-3.445.02-5.168zm4.19-5.076c-.458.092-.817.166-1.117.5-.359.945-.738 2-1.077 2.945 3.532.704 6.705.704 10.258 0-.36-.944-.739-2-1.078-2.945-.3-.334-.679-.408-1.118-.5-1.636-.39-4.23-.39-5.867 0zm9.141 6.576v-.908c-.24-.407-.558-.296-.997-.296-.899.278-1.577.5-2.276.982-.04.185 0 .519.24.611.778 0 1.557.019 2.315.019.28-.074.519-.204.718-.408zm-12.413 0v-.908c.22-.407.559-.296.998-.296.898.278 1.576.5 2.255.982.04.185.02.519-.22.611-.778 0-1.556.019-2.335.019a1.461 1.461 0 01-.698-.408z","fill":"#000","fill-rule":"evenodd"}})])
          )
        }
      }
    